<template>
<div class="dropdown">
  <slot
    :didClickOutside="didClickOutside"
    :didClickInside="didClickInside"
    :isOpen="isOpen"
  >
  </slot>
</div>
</template>


<script>
export default {
  data () {
    return {
      isOpen: false
    }
  },

  methods: {
    didClickOutside: function (e) {
      this.isOpen = false
    },

    didClickInside: function () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
